import { PedidoVentaForm } from "./PedidoVentaForm";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { pedidoventaStartAdd, pedidoventaStartUpdate } from "../../../actions";
import { FormUi } from "../../ui";
import { Form } from "antd";
import { cleanEmptyChildren, parseDateFormatBackEnd } from "../../../helpers";
import { EstadoPedidoVentaConstants } from "../../../helpers/constants";
const initialValues = (data = {}) => ({
  id: data?.id || dayjs().valueOf(),
  nombrecompleto: data?.cliente?.nombrecompleto || null,
  tipodocumento: data?.cliente?.tipodocumento || null,
  nrodocumento: data?.cliente?.nrodocumento || null,
  vendedor: data?.vendedor || null,
  fechapedido: dayjs(data?.fechapedido) || dayjs(),
  fechaentrega: dayjs(data?.fechaentrega) || dayjs(),
  moneda: data?.moneda || null,
  moneda_prefijo: data?.moneda_prefijo || null,
  observacion: data?.observacion || null,
  montosubtotal: parseFloat(data?.montosubtotal) || 0,
  montoigvtotal: parseFloat(data?.montoigvtotal) || 0,
  montototal: parseFloat(data?.montototal) || 0,
  detallepedidoventa: data?.detallepedidoventa || [],
  estadospedidoventa: data?.estadospedidoventa || [],
  estado: data?.estado || EstadoPedidoVentaConstants.BORRADOR,
  cliente:
    (data?.cliente && {
      ...data?.cliente,
      data: JSON.stringify(data?.cliente),
    }) ||
    null,
});

export const PedidoVentaScreen = ({ handleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const { activePedidoVenta } = useSelector((state) => state.pedidoventa);
  const handleSubmit = (values) => {
    let valuesData = {
      ...values,
      fechapedido: parseDateFormatBackEnd(values?.fechapedido),
      fechaentrega: parseDateFormatBackEnd(values?.fechaentrega),
      cliente: {
        ...(values?.cliente?.data ? JSON.parse(values?.cliente?.data) : {}),
        tipodocumento: values?.cliente?.tipodocumento,
      },
    };
    valuesData = cleanEmptyChildren(valuesData);
    if (activePedidoVenta) dispatch(pedidoventaStartUpdate(valuesData));
    else dispatch(pedidoventaStartAdd(valuesData));
    handleCloseForm();
  };
  return (
    <Form.Provider
      onFormFinish={(name, { values, forms }) => {
        const { FormPedidoVenta } = forms;
        if (name === "ItemDetalleForm") {
          let detallepedidoventa =
            FormPedidoVenta.getFieldValue("detallepedidoventa") || [];
          const _existe =
            detallepedidoventa?.filter((x) => x.id === values?.id)?.length > 0
              ? true
              : false;
          values = {
            ...values,
            valorigv: parseFloat(
              parseFloat(values?.cantidad * values?.valorigvunitario).toFixed(
                4,
              ),
            ),
            valorventabruto: parseFloat(
              parseFloat(values?.cantidad * values?.valorunitario).toFixed(4),
            ),
            valorventa: parseFloat(
              parseFloat(values?.cantidad * values?.preciounitario).toFixed(4),
            ),
          };
          if (!_existe) detallepedidoventa = [...detallepedidoventa, values];
          else
            detallepedidoventa = detallepedidoventa.map((e) =>
              e.id === values.id ? values : e,
            );
          FormPedidoVenta.setFieldValue(
            "detallepedidoventa",
            detallepedidoventa,
          );
        }
      }}
    >
      <FormUi
        name="FormPedidoVenta"
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(
          activePedidoVenta || {
            moneda: activeEmpleado?.empresa?.moneda,
            monedaprefijo: activeEmpleado?.empresa?.moneda_prefijo,
            vendedor: activeEmpleado?.id,
          },
        )}
        handleSubmit={handleSubmit}
        form={form}
      >
        <PedidoVentaForm handleCloseForm={handleCloseForm} />
      </FormUi>
    </Form.Provider>
  );
};
